import React, { createContext, useState, useContext } from "react";

const ExpansionContext = createContext();

export const useExpansion = () => useContext(ExpansionContext);

export const ExpansionProvider = ({ children }) => {
  // 1. Ciudad seleccionada (se borra al refrescar)
  const [selectedCity, setSelectedCity] = useState(null);
  
  // 2. Las rutas nuevas que has creado
  const [candidateRoutes, setCandidateRoutes] = useState([]);
  
  // 3. El borrador actual (por si te cambias de pestaña a mitad de edición)
  const [draftRoute, setDraftRoute] = useState({ name: "", color: "#EAC024", stops: [] });

  // 4. Qué rutas están visibles (ojito activado)
  const [visibleCandidateIds, setVisibleCandidateIds] = useState(new Set());

  return (
    <ExpansionContext.Provider value={{
      selectedCity, setSelectedCity,
      candidateRoutes, setCandidateRoutes,
      draftRoute, setDraftRoute,
      visibleCandidateIds, setVisibleCandidateIds
    }}>
      {children}
    </ExpansionContext.Provider>
  );
};